<!--  -->
<template>
  <div>
    <div class="header">
      <el-form inline>
        <el-form-item label="员工姓名：">
          <el-input v-model="form.Name" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="员工ID：">
          <el-input v-model="form.UserId" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="员工手机号：">
          <el-input
            v-model="form.Mobile"
            placeholder="请输入"
            @input="handleMobile"
            :maxlength="11"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="员工邮箱：">
          <el-input v-model="form.Email" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="screening">筛选</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 100%; overflow: hidden">
      <el-button class="batch-decr-credit" type="primary" @click="uploadDialogVisible = true">
        批量积分核销
      </el-button>
    </div>
    <div class="table-list">
      <el-table :data="tableData" v-loading="tableLoading" :row-class-name="tableRowClassName">
        <el-table-column label="员工ID" prop="UserId"></el-table-column>
        <el-table-column label="员工姓名" prop="Name"></el-table-column>
        <el-table-column label="员工职务" prop="Position"></el-table-column>
        <el-table-column label="所属部门" prop="Department"></el-table-column>

        <el-table-column label="员工手机号" prop="Mobile"></el-table-column>

        <el-table-column label="员工邮箱" prop="Email"></el-table-column>

        <el-table-column label="剩余积分" prop="Score" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="operate-button" @click="showDecrDialog(scope.row)">
              {{ Number(scope.row.Score) &lt;= 0 ? '-' : '积分核销' }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; float: right">
        <el-pagination
          style="background-color: #ffffff"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="g_pageSizesConfig"
          :page-size="page_size"
          :current-page="page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <!-- 单人核销弹窗 -->
    <el-dialog
      class="my-dialog"
      title="积分核销"
      :visible.sync="decrDialogVisible"
      @closed="closeDecrDialog"
      width="400px"
    >
      <el-form>
        <el-form-item label="核销分数： " label-width="120px">
          <el-input
            v-model.trim="decrCounts"
            placeholder="请输入核销分数"
            style="width: 200px"
            @input="handleDecr"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="decrDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="DecrCreditByUser">确定</el-button>
      </div>
    </el-dialog>
    <!-- 上传弹窗 -->
    <el-dialog
      class="my-dialog"
      :title="uploadDialogTitle"
      :visible.sync="uploadDialogVisible"
      @closed="closeUploadDialog"
      width="600px"
    >
      <div class="before-import" v-if="!progressStatus.length">
        <el-upload
          ref="upload"
          class="batch-upload"
          drag
          action=""
          :show-file-list="false"
          :http-request="handleRequest"
          :before-upload="onBeforeUpload"
          v-if="!Object.keys(aimFile).length"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload>
        <div
          :class="{
            'file-content': true,
            'error-text': aimFile.status === 'error',
          }"
          v-if="Object.keys(aimFile).length"
        >
          <el-image
            style="width: 80px; height: 90px"
            src="https://baike-med-1256891581.file.myqcloud.com/2021109/eb18ae10-28a9-11ec-8dbe-ad3f6ba5fe4b_0.png"
          ></el-image>
          <Ellipsis
            class="file-name"
            :str="aimFile.fileName"
            suffix="..."
            :max-length="16"
            :offset="6"
          ></Ellipsis>
          <div>
            <i
              :class="{
                'el-icon-success': aimFile.status === 'success',
                'icon-success': aimFile.status === 'success',
                'el-icon-warning': aimFile.status === 'error',
                'icon-error': aimFile.status === 'error',
                'el-icon-loading': aimFile.status === 'loading',
                'icon-loading': aimFile.status === 'loading',
              }"
            ></i>
            <span class="progress">{{ (aimFile.percent * 100).toFixed(2) }} %</span>
          </div>
          <div
            :class="{
              'upload-progress': true,
              'error-progress': aimFile.status === 'error',
            }"
            :style="{
              width: `${aimFile.percent * 100}%`,
            }"
          ></div>
          <el-button
            style="width: 120px; margin-top: 20px"
            @click="resetUpload"
            :disabled="aimFile.percent != 1"
          >
            重新上传
          </el-button>
        </div>
        <div class="el-upload__tip">
          <p v-if="!Object.keys(aimFile).length">参照模版整理文件，可将文件拖拽到此区域</p>
          <p v-if="!Object.keys(aimFile).length">目前仅支持xlsx格式</p>
          <el-button
            style="width: 200px; margin-top: 20px"
            type="primary"
            @click="BatchDecrCredit"
            :disabled="aimFile.percent != 1"
          >
            导入
          </el-button>
          <el-button style="margin: 0; font-weight: 400" type="text" @click="getTemplate">
            下载导入模版
          </el-button>
        </div>
      </div>
      <div class="import-box" v-else>
        <div class="importing" v-if="progressStatus === 'importing'">
          <div class="import-bar">
            <i class="el-icon-loading icon-loading"></i>
            <Ellipsis
              class="file-name"
              :str="aimFile.fileName"
              suffix="..."
              :max-length="16"
              :offset="6"
            ></Ellipsis>
            <span class="progress">{{ uploadPercentage }} %</span>
            <div
              class="upload-progress"
              :style="{
                width: `${uploadPercentage}%`,
              }"
            ></div>
          </div>
          <p class="import-tips">文件正在导入，请稍等</p>
        </div>
        <div class="import-result" v-else>
          <el-image style="width: 72px; height: 72px" :src="importIconUrl"></el-image>
          <div style="color: #939599; font-size: 14px; margin-top: 16px">{{ importTips }}</div>
          <p class="import-tips" v-html="importResult"></p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
import { BatchDecrCredit, GetStaffInforRecord, DecrCreditByUser } from '@/api/staffManagement.js';
import { postfixFun } from '@/utils/util';
import Ellipsis from '@/components/ellipsis';
import { GetRosterTemplate, getUploadSignApi } from '@/api/common';
import config from '@/config';
export default {
  components: {
    Ellipsis,
  },
  filters: {
    handleTime(val) {
      const date = new Date(val * 1000 + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '/');
    },
    handleStatus(val) {
      if (val === 1) {
        return '待审核';
      }
      if (val === 2) {
        return '已通过';
      }
      if (val === 3) {
        return '未通过';
      }
    },
    handleUserType(val) {
      if (val === 1) {
        return '员工';
      }
      if (val === 2) {
        return '医生';
      }
    },
    handleContext(val) {
      return val.substr(0, 20);
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      uploadDialogVisible: false,
      decrDialogVisible: false,
      decrCounts: '',
      maxCredit: 0,
      choseUserId: '',
      aimFile: {},
      abortSign: [{}],
      fileUrl: '',
      progressStatus: '',
      importResult: '',
      uploadPercentage: 0,
      importTips: '',
      tableLoading: false,
      form: {
        UserId: '',
        Mobile: '',
        Name: '',
        Email: '',
      },
      page_index: 1,
      page_size: 10,
      total: 0,
      tableData: [],
    };
  },
  computed: {
    uploadDialogTitle() {
      if (this.aimFile.status === 'loading') {
        return '正在上传，请勿关闭此弹窗或标签页';
      }
      return '批量积分核销';
    },
  },
  watch: {
    progressStatus: {
      handler(val) {
        if (val === 'success') {
          this.importIconUrl =
            'https://baike-med-1256891581.file.myqcloud.com/2021102/943c8dc0-2a41-11ec-a2fa-c39d640f9a6a_0.png';
          this.importTips = '导入成功';
        } else if (val === 'templateError' || val === 'error') {
          this.importIconUrl =
            'https://baike-med-1256891581.file.myqcloud.com/2021100/94395970-2a41-11ec-a2fa-c39d640f9a6a_0.png';
          this.importTips = '导入失败';
        }
      },
    },
  },
  created() {
    this.page_size = 10;
    this.getList();
  },
  methods: {
    handleDecr(e) {
      const filtered = e.replace(/^0|[^\d]/g, '');
      if (this.decrCounts !== filtered) {
        this.decrCounts = filtered;
      }
    },
    handleMobile(e) {
      const filtered = e.replace(/^0|[^\d]/g, '');
      if (this.form.Mobile !== filtered) {
        this.form.Mobile = filtered;
      }
    },
    showDecrDialog(staff) {
      if (staff.Score <= 0) return;
      this.decrDialogVisible = true;
      this.maxCredit = staff.Score;
      this.choseUserId = staff.UserId;
    },
    closeDecrDialog() {
      this.maxCredit = 0;
      this.decrCounts = '';
      this.choseUserId = '';
    },
    closeUploadDialog() {
      this.progressStatus = '';
      this.aimFile = {};
    },
    DecrCreditByUser() {
      if (this.decrCounts > this.maxCredit) {
        this.$message.error('核销分数需小于用户积分');
        return;
      }
      DecrCreditByUser({
        UserId: this.choseUserId,
        Score: this.decrCounts,
      })
        .then(() => {
          this.decrDialogVisible = false;
          this.$message.success('核销成功');
          this.getList();
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    BatchDecrCredit() {
      this.progressStatus = 'importing';
      this.uploadPercentage = 0;
      const mission = setInterval(() => {
        BatchDecrCredit({
          FileUrl: this.fileUrl,
        })
          .then((res) => {
            switch (res.Status) {
              case 1:
                // 仍需等待
                if (this.uploadPercentage < 80) {
                  this.uploadPercentage += 10;
                } else if (this.uploadPercentage < 90) {
                  this.uploadPercentage += 2;
                } else if (this.uploadPercentage < 99) {
                  this.uploadPercentage += 1;
                }
                break;
              case 6:
                this.progressStatus = 'success';
                this.importResult = `本次导入${res.Count}条数据`;
                clearInterval(mission);
                this.getList();
                break;
              case 3:
                this.progressStatus = 'templateError';
                this.importResult = `文件内容与模板不符，请<a href="${res.FileUrl}" target="_blank">下载导入模版</a>参照调整后重新上传`;
                clearInterval(mission);
                break;
              default:
                this.progressStatus = 'error';
                this.importResult = `文件数据错误，请<a href="${res.FileUrl}" target="_blank">下载错误文件</a>检查后再上传`;
                clearInterval(mission);
                break;
            }
          })
          .catch((e) => {
            clearInterval(mission);
            this.importTips = `发生错误：${e.message}`;
            this.progressStatus = 'error';
          });
      }, 1000);
    },
    resetUpload() {
      this.aimFile = {};
      this.fileUrl = '';
    },
    getTemplate() {
      GetRosterTemplate({
        TemplateKey: 'DecrCredit',
      })
        .then((res) => {
          this.g_tourl(res.TemplateUrl, { open: true });
        })
        .catch(() => {
          this.$message.error('下载失败');
        });
    },
    onBeforeUpload(file) {
      console.log(file);
      const isXLS =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel';

      if (!isXLS) {
        this.$message.error('上传文件只能是XLSX!');
      }
      this.suffix = `.${file.name.split('.')[1]}`;
      return isXLS;
    },
    async getTokenFunc() {
      const res = await getUploadSignApi({
        app_id: config.cosAppId,
        credentials: 1,
        suffix: this.suffix,
      });
      const { sessionToken, tmpSecretId, tmpSecretKey } = res?.data?.credentials || {};
      const {
        cdn_url: cdnUrl,
        key,
        startTime,
        expiredTime,
        Region: region,
        Bucket: bucket,
      } = res?.data || {};
      return {
        tmpSecretId,
        tmpSecretKey,
        sessionToken,
        cdnUrl,
        key,
        startTime,
        expiredTime,
        region,
        bucket,
      };
    },
    // 点击上传文档
    clickUploadFileBtn() {
      this.uploadDialogVisible = true;
    },
    async handleRequest(file) {
      const fileConfig = {
        uid: file.file.uid,
        fileName: file.file.name,
        status: 'loading',
        percent: 0,
      };
      this.aimFile = fileConfig;
      this.wholeFile = file.file;
      const { postfix } = postfixFun(file.file.name);
      try {
        const cosParams = {
          fileObject: file.file,
          suffix: postfix,
        };
        const res = await this.putCosObject(
          cosParams,
          undefined,
          (progressData) => {
            this.aimFile.percent = progressData.percent;
            console.log(this.aimFile.percent);
            // console.log(that.abortSign);
          },
          this.getTokenFunc,
        );
        this.aimFile.status = 'success';
        this.fileUrl = res.data;
      } catch (err) {
        console.log('error', err);
        // this.handleListener('remove');
        this.aimFile.status = 'error';
      }
    },
    screening() {
      this.page_index = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    tableRowClassName(row) {
      if (row.row.status === 3) {
        return 'warning-row';
      }
    },
    getList() {
      this.tableLoading = true;
      const req = {
        PageNum: this.page_index,
        PageSize: this.page_size,
      };
      GetStaffInforRecord(Object.assign(req, this.form))
        .then((res) => {
          this.tableData = res.Datas;
          this.total = res.Total;
          this.tableLoading = false;
        })
        .catch(() => {
          this.$message.error('获取失败');
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  color: #c0c4cc;
}
.header {
  display: flex;
  align-items: top;
  border-bottom: 1px solid rgb(241, 241, 241);
}
.batch-decr-credit {
  float: right;
  margin-top: 24px;
  margin-right: 24px;
}
.my-dialog {
  display: flex;
  align-items: center;
  flex-direction: column;
  .batch-upload {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 50px;
    color: #c4c7cc;
    .el-icon-plus {
      margin-top: 65px;
    }
  }
  .el-upload__tip {
    margin-top: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
  }
  .file-content {
    width: 240px;
    padding-top: 8px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    &.error-text {
      color: #f05942;
    }
    .icon-success {
      color: #76c84d;
    }
    .icon-error {
      color: #f05942;
    }
    .icon-loading {
      color: #2f96ff;
    }
    .file-name {
      width: 240px;
      text-align: center;
      padding: 8px;
      overflow: hidden;
    }
    .icon-delete {
      color: grey;
      padding: 0 20px;
      cursor: pointer;
    }
  }
  .importing {
    display: flex;
    align-items: center;
    flex-direction: column;
    .import-bar {
      background: #f7f9fc;
      width: 400px;
      height: 28px;
      padding-top: 7px;
      padding-left: 16px;
    }
  }

  .import-tips {
    margin-top: 24px;
    color: #626366;
  }

  .import-result {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .upload-progress {
    height: 2px;
    background: #2f96ff;
    box-sizing: border-box;
    &.error-progress {
      background: #f05942;
    }
  }
}

.table-list {
  margin-top: 24px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  ::v-deep .el-table__header-wrapper .el-table__header {
    color: #303133;
    background: rgba(216, 216, 216, 0.1);
  }
  ::v-deep .el-table .cell {
    font-size: 14px;
  }
  ::v-deep .el-table__empty-text {
    line-height: 0;
  }
  .text-button {
    cursor: pointer;
    color: #2f96ff;
  }
  .operate-button {
    display: inline-block;
    width: 4em;
    text-align: center;
    color: #2f96ff;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
